module.exports = __webpack_public_path__ + "img/check-icon.11effbf1.svg";